import client from 'data/client';
import { ProductData } from 'data/types/product';
import { normalizeProduct } from 'model/product';

const getProduct = async (brandId: string) => {
  const response = await client.get<ProductData>(
    `reporting/product?brandId=${brandId}`,
  );
  return normalizeProduct(response.data);
};

export default getProduct;
